﻿export default function () {

	document.addEventListener('DOMContentLoaded', function () {
		const buttons = document.querySelectorAll('.js-global-search-button');
		const sections = document.querySelectorAll('.js-global-search-section');

		buttons.forEach(function (button) {
			button.addEventListener('click', function () {
				const tabValue = this.getAttribute('data-linked-tab');
				buttons.forEach(btn => btn.classList.remove('active'));
				this.classList.add("active");

				sections.forEach(function (section) {
					if (section.getAttribute('data-linked-tab') === tabValue) {
						section.classList.add("active");
					} else {
						section.classList.remove("active");
					}
				});
			});
		});
	});


}